module.exports = "/_next/static/images/DeliveryWarehousesETL@2x-ab688a597327e2ee1a2f557661848591.webp";